// extracted by mini-css-extract-plugin
module.exports = {"ldsRing":"style-module__ldsRing___pQvjf"};